// source: pbtypes/gen/vehicle_params_for_phone/runmode_switching_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_vehicle_params_for_phone_alert_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/alert_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_alert_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.RunmodeSwitchingOption', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.RunmodeSwitchingOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.RunmodeSwitchingOption.displayName = 'proto.vehicle_params_for_phone.RunmodeSwitchingOption';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.RunmodeSwitchingOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.toObject = function(includeInstance, msg) {
  var f, obj = {
optionName: jspb.Message.getFieldWithDefault(msg, 1, ""),
runMode: jspb.Message.getFieldWithDefault(msg, 2, ""),
detail: jspb.Message.getFieldWithDefault(msg, 3, ""),
image: jspb.Message.getFieldWithDefault(msg, 4, ""),
alert: (f = msg.getAlert()) && pbtypes_gen_vehicle_params_for_phone_alert_pb.Alert.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.RunmodeSwitchingOption;
  return proto.vehicle_params_for_phone.RunmodeSwitchingOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOptionName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRunMode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImage(value);
      break;
    case 5:
      var value = new pbtypes_gen_vehicle_params_for_phone_alert_pb.Alert;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_alert_pb.Alert.deserializeBinaryFromReader);
      msg.setAlert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.RunmodeSwitchingOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRunMode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAlert();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_vehicle_params_for_phone_alert_pb.Alert.serializeBinaryToWriter
    );
  }
};


/**
 * optional string option_name = 1;
 * @return {string}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.getOptionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.setOptionName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string run_mode = 2;
 * @return {string}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.getRunMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.setRunMode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string detail = 3;
 * @return {string}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string image = 4;
 * @return {string}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.setImage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Alert alert = 5;
 * @return {?proto.vehicle_params_for_phone.Alert}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.getAlert = function() {
  return /** @type{?proto.vehicle_params_for_phone.Alert} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_alert_pb.Alert, 5));
};


/**
 * @param {?proto.vehicle_params_for_phone.Alert|undefined} value
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
*/
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.setAlert = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption} returns this
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.clearAlert = function() {
  return this.setAlert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.RunmodeSwitchingOption.prototype.hasAlert = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
